const {registerModule} = window;

/** Keep in sync: logoGrid.njk (images | length > 12), this constant, logoGrid.scss (:nth-child(n + 13)) */
const INITIAL_VISIBLE_COUNT = 12;

class LogoGrid {
  constructor(element) {
    this.element = element;
    this.initialize();
  }

  bindEvents() {
    this.ui.$toggle.addEventListener('click', () => {
      this.handleToggle();
    });
  }

  bindUI() {
    this.ui = {};
    this.ui.$grid = this.element.querySelector('[data-ref="grid"]');
    this.ui.$toggle = this.element.querySelector('[data-ref="toggle"]');
    this.ui.$toggleLabel = this.element.querySelector('[data-ref="toggle-label"]');
  }

  handleToggle() {
    this.element.classList.toggle('logo-grid__panel--is-collapsed');
    this.updateUi();
  }

  initialize() {
    this.bindUI();
    const $cells = this.ui.$grid.querySelectorAll('.logo-grid__cell');

    if ($cells.length <= INITIAL_VISIBLE_COUNT || !this.ui.$toggle) {
      return;
    }

    this.element.classList.add('logo-grid__panel--is-collapsed');
    this.ui.$toggle.removeAttribute('hidden');
    this.bindEvents();
    this.updateUi();
  }

  updateUi() {
    const isCollapsed = this.element.classList.contains('logo-grid__panel--is-collapsed');
    this.ui.$toggle.setAttribute('aria-expanded', (!isCollapsed).toString());
    this.ui.$toggleLabel.innerText = isCollapsed ? 'Show More' : 'Show Less';
  }
}

registerModule('LogoGrid', LogoGrid);
